import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { getApp } from "../app";
import { Subscription } from "rxjs";
import { getAuthErrorCode } from "../../../../shared/models/auth-error-codes";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
})
export class ErrorComponent implements OnInit, OnDestroy {
  private _routeParamsSubscription: Subscription = new Subscription();

  public code: string = "";
  public tenantId: string = "";

  app = getApp((app) => {
    this.app = app;
  });

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this._routeParamsSubscription = this.route.queryParams.subscribe(
      async (params) => {
        this.code = params.code ?? "";
        this.tenantId = params.tid ?? "";
      }
    );
  }

  getMessage(): string {
    return getAuthErrorCode(this.code, this.app.language);
  }

  goBack(): void {
    this.router.navigateByUrl("/login");
  }

  ngOnDestroy(): void {
    if (this._routeParamsSubscription) {
      this._routeParamsSubscription.unsubscribe();
    }
  }
}
